import Constants from '../Constants';
import * as Helpers from '../Utilities/Common';

const { GET_REPORTS, REPORTS_LOADING } = Constants;

export const getReports = (token, query = {}, id) => async (dispatch) => {
    
    dispatch(reportLoading());
    
    const response = await Helpers.makeRequest(token, "STATS", "GET", "", query, id);

    if(response.result && !response.blob){
        dispatch({ type: GET_REPORTS, payload: { data: response.data, query } });
    }

    if (response.result && response.blob) {
        dispatch(reportLoading(false));
        const file = window.URL.createObjectURL(response.blob);
        window.location.assign(file);
    }
}

export const reportLoading = (state = true) => ({ type: REPORTS_LOADING, payload: state });



// WEBPACK FOOTER //
// ./src/Actions/ReportActions.js